var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinktreeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2084,
    viewBox: "-7.19 -5.39 814.38 679.39",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.53 18.87c-13.49-24.26-48.54-24.26-62.02 0L3.6 439.45c-10.79 21.57 5.39 45.83 29.66 45.83h156.4v159.06c0 16.18 13.49 29.66 29.67 29.66h91.68c16.18 0 29.66-13.48 29.66-29.66V485.28h-43.14c-18.88 0-32.36-13.48-35.06-29.66 0-5.39 0-10.78 2.7-16.23l129.44-234.55z",
    fill: "#39e09b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M502.47 18.87c13.49-24.26 48.54-24.26 62.02 0L796.4 439.45c10.79 21.57-5.39 45.83-29.66 45.83H613.03v159.06c0 16.18-13.48 29.66-29.69 29.66h-97.05c-16.18 0-29.66-13.48-29.66-29.66V485.28h43.15c18.87 0 32.35-13.48 35.05-29.66 0-5.39 0-10.78-2.7-16.23L402.7 204.9z",
    fill: "#28bf7b"
  })));
}

export default SvgLinktreeIcon;